(function () {
  function init(root) {
    if (!root || root.dataset.ctInit === '1') return;
    root.dataset.ctInit = '1';

    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-ct-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('.ct-panel'));

    function sync(panel) {
      var row = panel.querySelector('[data-ct-row]');
      var prev = panel.querySelector('[data-ct-prev]');
      var next = panel.querySelector('[data-ct-next]');
      if (!row || !prev || !next) return;
      var max = row.scrollWidth - row.clientWidth;
      prev.disabled = row.scrollLeft <= 4;
      next.disabled = row.scrollLeft >= max - 4;
    }

    function select(i, focus) {
      tabs.forEach(function (t, n) {
        var on = n === i;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
      });
      panels.forEach(function (p, n) {
        if (n === i) { p.removeAttribute('hidden'); } else { p.setAttribute('hidden', ''); }
      });
      var panel = panels[i];
      if (panel) {
        var row = panel.querySelector('[data-ct-row]');
        if (row) row.scrollLeft = 0;
        sync(panel);
      }
      if (focus && tabs[i]) tabs[i].focus();
    }

    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(i); });
      t.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); select((i + 1) % tabs.length, true); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); select((i - 1 + tabs.length) % tabs.length, true); }
      });
    });

    panels.forEach(function (panel) {
      var row = panel.querySelector('[data-ct-row]');
      var prev = panel.querySelector('[data-ct-prev]');
      var next = panel.querySelector('[data-ct-next]');
      if (!row) return;
      function step(dir) { row.scrollBy({ left: dir * Math.round(row.clientWidth * 0.8), behavior: 'smooth' }); }
      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });
      row.addEventListener('scroll', function () { sync(panel); }, { passive: true });
      window.addEventListener('resize', function () { sync(panel); });
      sync(panel);
    });

    var nav = root.querySelector('.ct-nav');
    var navWrap = root.querySelector('.ct-nav-wrap');
    if (nav && navWrap) {
      var navSync = function () {
        navWrap.classList.toggle('ct-nav-end', nav.scrollLeft >= (nav.scrollWidth - nav.clientWidth - 4));
      };
      nav.addEventListener('scroll', navSync, { passive: true });
      window.addEventListener('resize', navSync);
      navSync();
    }
  }

  function boot() {
    document.querySelectorAll('.collectie-tabs').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:select', boot);
})();
